export default {
  parkData: { // 本地园区数据
    method: 'get',
    url: 'data/park_data.json'
  },
  getParkJson: { // 园区数据
    method: 'get',
    url: 'http://dazhoucdn.whhda.xyz/park_data.json'
  },
  agencyData: { // 本地企业数据
    method: 'get',
    url: 'data/agency_data.json'
  },
  getAgencyJson: { // 企业数据
    method: 'get',
    url: 'http://dazhoucdn.whhda.xyz/agency_data.json'
  },
  login: {
    method: 'post',
    url: 'http://119.23.23.164/oauth/token'
  },
  fileToken: {
    method: 'get',
    url: 'http://119.23.23.164/oauth/file_upload'
  },
  upFile: {
    method: 'post',
    url: 'http://119.23.23.164/oauth/file_upload'
  },
  getFile: {
    method: 'get',
    url: 'dazhoucdn.whhda.xyz'
  }
}
